import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
Vue.use(Vuex)

const state = {
  count: 0, // 直播时长
  adminleftnavnum: '/', //管理后台左侧导航
  newStatus: null, // 读取消息状态
  uploading_list: [], //正在上传的文件列表
  uploading_over_list: [], //上传完成的文件信息暂存在这里
  uploading_reupload_list: [], //上传完成的文件信息暂存在这里

  uploadRoaminglist: [], //正在上传的文件列表
  uploadoverRoaminglist: [], //上传完成的文件信息暂存在这里
  uploadreuploadRoaminglist: [], //上传完成的文件信息暂存在这里

  // 漫游替换
  roamingReplace: [],
  roamingOverReplace: [],
  roamingStagReplace: [],

  //作品管理本地漫游包
  uploadWorksRoamd: [],
  uploadWorksRoamdover: [],
  uploadWorksRoamdreup: [],

  c_edit: null,

  picker_colors: [], //色彩选择器组件常用颜色
  rullm_data: null,
  show_list:null,
  nav_senced_id:null,
  rullm:[],
  routerName:''
  }
const mutations = {
  increment(state, time) {
    try {
      localStorage.setItem('live-count', time)
      state.count = time
    } catch (e) {
      //TODO handle the exception
      Cookies.set('live-count', time)
    }
  },
  changeNew(state, news) {
    state.newStatus = news // 0: 全部已读  1：单个查看
  },
  setRullM(state,news){
    state.rullm = news
  },
  setrouterName(state,news){
    state.routerName = news
  },
  changeShowList(state,type){
    state.show_list = type
  },
  changeNavShow(state,type){
    state.nav_senced_id = type
  },
    //对上传中的文件数据进行处理
  addUpload: function (state, data) {
    state.uploading_list.push(data)
    if (data.old_id) {
      state.uploading_reupload_list.push(data.old_id)
    } else {
      state.uploading_reupload_list.push('普通上传')
    }
  },

  addroamingUpload: function (state, data) {
    state.uploadRoaminglist.push(data)
    if (data.old_id) {
      state.uploadreuploadRoaminglist.push(data.old_id)
    } else {
      state.uploadreuploadRoaminglist.push('普通上传')
    }
  },
  // 作品素材添加
  addWorksUpload: function (state, data) {
    state.uploadWorksRoamd.push(data)
    if (data.old_id) {
      state.uploadWorksRoamdreup.push(data.old_id)
    } else {
      state.uploadWorksRoamdreup.push('普通上传')
    }
  },
  updateUpload: function (state, data) {
    //更新上传进度
    state.uploading_list.forEach(function (item, index) {
      if (item.fileid == data.name) {
        state.uploading_list[index].num = data.num
      }
    })
  },
  updateRoamingUpload: function (state, data) {
    //更新上传进度
    state.uploadRoaminglist.forEach(function (item, index) {
      if (item.fileid == data.name) {
        state.uploadRoaminglist[index].num = data.num
      }
    })
  },
  updateWorksUpload: function (state, data) {
    //更新上传进度
    state.uploadWorksRoamd.forEach(function (item, index) {
      if (item.fileid == data.name) {
        state.uploadWorksRoamd[index].num = data.num
      }
    })
  },
  deleteUpload: function (state, data) {
    if (!data) {
      state.uploading_list
    } else {
      //删除上传中的文件
      state.uploading_list.forEach(function (item, index) {
        if (item.fileid == data) {
          state.uploading_list.splice(index, 1)
          state.uploading_reupload_list.splice(index, 1) //这里也进行一次修改
        }
      })
    }
  },

  deleteRoamingUpload: function (state, data) {
    //删除上传中的文件
    state.uploadRoaminglist.forEach(function (item, index) {
      if (item.fileid == data) {
        state.uploadRoaminglist.splice(index, 1)
        state.uploadreuploadRoaminglist.splice(index, 1) //这里也进行一次修改
      }
    })
  },
  deleteWorksUpload: function (state, data) {
    //删除上传中的文件
    state.uploadWorksRoamd.forEach(function (item, index) {
      if (item.fileid == data) {
        state.uploadWorksRoamd.splice(index, 1)
        state.uploadWorksRoamdreup.splice(index, 1) //这里也进行一次修改
      }
    })
  },
  //对上传完成的文件状态进行更改
  addUploadOver: function (state, data) {
    //添加上传成功的文件
    state.uploading_over_list.push(data)
  },
  roamingaddUploadOver: function (state, data) {
    //添加上传成功的文件
    state.uploadoverRoaminglist.push(data)
  },
  addUploadWorksOver: function (state, data) {
    //添加上传成功的文件
    state.uploadWorksRoamdreup.push(data)
  },
  deleteUploadOver: function (state, data) {
    //清空上传中的文件
    state.uploading_over_list = []
  },

  addPickerColors: function (state, data) {
    let reg = new RegExp(' ', 'g')
    let new_data = data.replace(reg, '')
    if (state.picker_colors.indexOf(new_data) == -1) {
      let arr = [new_data]
      state.picker_colors = arr.concat(state.picker_colors)
    }
  },

  setRullmData: function (state, data) {
    state.rullm_data = data
  },

  //漫游 替换
  addReplaceUpload: function (state, data) {
    state.roamingReplace.push(data)
    if (data.old_id) {
      state.roamingStagReplace.push(data.old_id)
    } else {
      state.roamingStagReplace.push('普通上传')
    }
  },
  //更新上传进度
  updateReplaceUpload: function (state, data) {
    state.roamingReplace.forEach(function (item, index) {
      if (item.fileid == data.name) {
        state.roamingReplace[index].num = data.num
      }
    })
  },
  //删除上传中的文件
  deleteReplaceUpload: function (state, data) {
    state.roamingReplace.forEach(function (item, index) {
      if (item.fileid == data) {
        state.roamingReplace.splice(index, 1)
        state.roamingStagReplace.splice(index, 1) //这里也进行一次修改
      }
    })
  }
}
const getters = {
  getCount(state) {
    return state.count
  },
  getNewStatus(state) {
    return state.newStatus
  },
  getPickerColors(state) {
    return state.picker_colors
  }
}

const actions = {
  deleteUpload: function (context, data) {
    console.log('转到mutations')
    context.commit('deleteUpload', data)
  },
  deleteRoamingUpload: function (context, data) {
    console.log('转到mutations')
    context.commit('deleteRoamingUpload', data)
  },
  delateReplaceRoaming: function (context, data) {
    console.log('转到mutations')
    context.commit('deleteReplaceUpload', data)
  },
  deleteWorksUpload: function (context, data) {
    console.log('转到mutations')
    context.commit('deleteWorksUpload', data)
  }
}
//注册Store
export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/store.js